import Pickaday from 'dbushell/Pikaday';

class firefoxDatepicker {

  constructor(){
    this.startInput   = document.querySelector('[data-trigger="startinput"]');
    this.endInput     = document.querySelector('[data-trigger="endinput"]');

    this.pickerFr = {
      previousMonth : 'Mois précédent',
      nextMonth     : 'Mois suivant',
      months        : ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
      weekdays      : ['Dimanche','Lundi','Mardi','Mercrei','Jeudi','Vendredi','Samedi'],
      weekdaysShort : ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam']
    };

    this._init();
  }

  _init(){
    if(this.startInput){
      this._createPicker(this.startInput, 'begin');
      this._createPicker(this.endInput, 'end');
    }
  }

  _createPicker(field, constant){
    const picker = new Pickaday({ 
      field: field,
      format: 'DD/MM/YYYY',
      i18n: this.pickerFr,
      firstDay: 1,
    });
  }
	_listentForSelection(){
		this.typeSelect.addEventListener('change', ()=>{
			const selectedID = this.typeSelect.options[this.typeSelect.selectedIndex].value;
			this.booking.type = selectedID;
		});
	}
}

export const firefoxdatepicker = new firefoxDatepicker();